import React, { StrictMode } from 'react'

export const withStrictMode = (Component: React.ReactElement, isStrictMode: boolean | undefined) => {
  return isStrictMode ? <StrictMode>{Component}</StrictMode> : Component
}
